
import React, { Component } from 'react';

import InstructionsPanel from './InstructionsPanel';
import PowerPiecePanel from './PowerPiecePanel';
import WinPanel from './WinPanel';
import PuzzleSelectPanel from './PuzzleSelectPanel';

import './../../../scss/App.scss';
import UnlockPuzzlePanel from './UnlockPuzzlePanel';
import Confetti from '../overlays/Confetti';


class OverlayManager extends Component {

	constructor(props){
		super(props);

		this.state = {
			"showPanel": "",
			"updateKey": 1,
			"showConfetti": false
		}

		//


		//

		window.ppz.overlayManager = this;
	}

	componentDidMount(){
		window.ppz.instructionsShown = false;
	}

	componentDidUpdate(prevProps) {

	}

	setPanel(panel){
		//console.log("setPanel: ", panel);

		this.setState({
			"showPanel": panel,
			"updateKey": (this.state.updateKey + 1)
		});
	}

	closeOverlay(){
		this.setState({
			"showPanel": ""
		});
	}

	renderPanel(){
		if(this.state.showPanel === "instructions"){
			return (
				<InstructionsPanel />
			);
		}
		else if(this.state.showPanel === "powerPieces"){
			return (
				<PowerPiecePanel />
			);
		}
		else if(this.state.showPanel === "win"){
			return (
				<WinPanel />
			);
		}
		else if(this.state.showPanel === "puzzleSelect"){
			return (
				<PuzzleSelectPanel />
			);
		}
		else if(this.state.showPanel === "unlockPuzzle"){
			return (
				<UnlockPuzzlePanel />
			);
		}
	}

	showConfetti(){
		this.setState({
			"showConfetti": true
		});
	}

	hideConfetti(){
		this.setState({
			"showConfetti": false
		});
	}

	renderConfetti(){
		if(this.state.showConfetti){
			return(
				<Confetti />
			);
		}
	}

	render(){
		if(this.state.showPanel !== ""){
			return(
				<div id="overlay" key={this.state.updateKey}>
					<div className="darkener"></div>
					{this.renderConfetti()}
					<div className="overlayPanel">
						{this.renderPanel()}
					</div>
				</div>
			);
		}
		else {
			return (
				<div></div>
			);
		}
	}
}

export default OverlayManager;


// WEBPACK FOOTER //
// ./src/js/components/overlays/OverlayManager.js